import { Document } from '../document.js';

export const Courses = [
  {
    course: "A Caregiver's Guide to Understanding and Supporting a Trauma Survivors",
    duration: 1.5,
    active: true,
  },
  { course: 'Abuse, Neglect, and Financial Exploitation', duration: 1.5, active: true },
  { course: 'Acknowledging Change and Loss: A Mindful Approach', duration: 1.5, active: true },
  { course: 'Addressing Hoarding Behaviors in Housing', duration: 1.5, active: true },
  { course: 'Advanced English, Part 1', duration: 3, active: true },
  { course: 'Advanced English, Part 2', duration: 3, active: true },
  { course: 'Advanced English, Part 3', duration: 3, active: true },
  { course: 'Advanced English, Part 4', duration: 3, active: true },
  { course: 'Advanced English, Part 5', duration: 3, active: true },
  { course: 'Advanced English, Part 6', duration: 3, active: true },
  { course: 'Advanced English, Part 7', duration: 2, active: true },
  { course: 'All About Food: Nutrition, Spending & Budgeting', duration: 1.5, active: true },
  {
    course: 'Alzheimer’s Disease and Related Dementia 1: Role of the Caregiver',
    duration: 4,
    active: true,
  },
  {
    course: 'Alzheimer’s Disease and Related Dementia 2: Introduction, Terminology & Stats',
    duration: 4,
    active: true,
  },
  {
    course: 'Alzheimer’s Disease and Related Dementia 3: Common Behaviors and Sundowning',
    duration: 4,
    active: true,
  },
  {
    course:
      'Alzheimer’s Disease and Related Dementia 4: Sleep Changes and Hallucinations, Home Safety, Wandering',
    duration: 4,
    active: true,
  },
  {
    course: 'Alzheimer’s Disease and Related Dementia 5: Assisting with Personal Hygiene',
    duration: 4,
    active: true,
  },
  {
    course: 'Alzheimer’s Disease and Related Dementia 6: Nutrition and Physical Activity',
    duration: 4,
    active: true,
  },
  { course: 'Anxiety : Panic, OCD & Paranoia', duration: 1.5, active: true },
  { course: 'Basic First Aid', duration: 1.5, active: true },
  { course: 'Beginner English, Part 1', duration: 3, active: true },
  { course: 'Beginner English, Part 2', duration: 3, active: true },
  { course: 'Beginner English, Part 3', duration: 3, active: true },
  { course: 'Beginner English, Part 4', duration: 3, active: true },
  { course: 'Beginner English, Part 5', duration: 3, active: true },
  { course: 'Beginner English, Part 6', duration: 3, active: true },
  { course: 'Beginner English, Part 7', duration: 2, active: true },
  { course: 'Blood Borne Pathogens', duration: 1.5, active: true },
  { course: 'Body Mechanics and Supporting Consumers with Transfers', duration: 1.5, active: true },
  {
    course: 'Body Mechanics, Heavy Transfers, and Mechanical Lifts (In Person)',
    duration: 6.5,
    active: true,
  },
  { course: 'Body Systems and Common Diseases', duration: 1.5, active: true },
  { course: 'Cancer Pain Management', duration: 1.5, active: true },
  { course: 'Career Exploration & Launch, Part 1', duration: 3, active: true },
  { course: 'Career Exploration & Launch, Part 2', duration: 3, active: true },
  { course: 'Career Exploration & Launch, Part 3', duration: 3, active: true },
  { course: 'Career Exploration & Launch, Part 4', duration: 3, active: true },
  { course: 'Career Exploration & Launch, Part 5', duration: 3, active: true },
  { course: 'Caring Compassionately for Yourself and Others', duration: 1.5, active: true },
  { course: 'Cognitive Impairments', duration: 1.5, active: true },
  { course: 'Collaborating Across the Care Team', duration: 1.5, active: true },
  { course: 'Communicating & Collaborating with Consumers', duration: 1.5, active: true },
  { course: 'Connection: A New Approach to Listening and Sharing', duration: 1.5, active: true },
  {
    course: 'Communicating with Consumers who Do Not Speak the Same Language as You',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Consumer and Provider Communication: Motivational Interviewing',
    duration: 1,
    active: true,
  },
  { course: 'COPD and Asthma', duration: 1.5, active: true },
  { course: 'CPR and AED', duration: 5.5, active: true },
  { course: 'CPR and First Aid', duration: 6.5, active: true },
  { course: 'Crisis Intervention: Verbal De-Escalation', duration: 4, active: true },

  {
    course: 'Crisis Intervention: Verbal De-Escalation - 3 Hours',
    duration: 3,
    active: true,
  },
  { course: 'Dementia and Alzheimer’s', duration: 1.5, active: true },
  { course: 'Depression, Bi-Polar & Other Mood Disorders', duration: 1.5, active: true },
  { course: 'Developmental & Intellectual Disabilities', duration: 1.5, active: true },
  { course: 'Diabetes', duration: 1.5, active: true },
  { course: 'Digital Literacy Level 1, Part 1', duration: 3, active: true },
  { course: 'Digital Literacy Level 1, Part 2', duration: 3, active: true },
  { course: 'Digital Literacy Level 1, Part 3', duration: 3, active: true },
  { course: 'Digital Literacy Level 1, Part 4', duration: 3, active: true },
  { course: 'Digital Literacy Level 1, Part 5', duration: 3, active: true },
  { course: 'Digital Literacy Level 2, Part 1', duration: 3, active: true },
  { course: 'Digital Literacy Level 2, Part 2', duration: 3, active: true },
  { course: 'Digital Literacy Level 2, Part 3', duration: 3, active: true },
  { course: 'Digital Literacy Level 2, Part 4', duration: 3, active: true },
  { course: 'Digital Literacy Level 2, Part 5', duration: 3, active: true },
  {
    course: 'Emergency and Disaster Preparedness 1: Climate Change and its Connection to Care',
    duration: 4,
    active: true,
  },
  {
    course:
      'Emergency and Disaster Preparedness 2: Vulnerability, Disproportionate Impact, and Environmental Justice',
    duration: 4,
    active: true,
  },
  {
    course: 'Emergency and Disaster Preparedness 3: Community Resilience and Emergency Planning',
    duration: 4,
    active: true,
  },
  {
    course:
      'Emergency and Disaster Preparedness 4: Protective Actions for Climate Related Emergencies',
    duration: 4,
    active: true,
  },
  {
    course:
      'Emergency and Disaster Preparedness 5: Responding to Climate Related Emergencies and Communication',
    duration: 4,
    active: true,
  },
  {
    course: 'Emergency and Disaster Preparedness 6: Post-Climate Related Emergency Trauma',
    duration: 4,
    active: true,
  },
  { course: 'Epilepsy & Seizures', duration: 1.5, active: true },
  { course: 'Establishing Healthy Emotional Boundaries', duration: 1.5, active: true },
  { course: 'Exploring Options Approach to Problem Solving', duration: 1.5, active: true },
  { course: 'Financial Literacy Level 1, Part 1', duration: 3, active: true },
  { course: 'Financial Literacy Level 1, Part 2', duration: 3, active: true },
  { course: 'Financial Literacy Level 1, Part 3', duration: 3, active: true },
  { course: 'Financial Literacy Level 1, Part 4', duration: 3, active: true },
  { course: 'Financial Literacy Level 1, Part 5', duration: 3, active: true },
  { course: 'Financial Literacy Level 2, Part 1', duration: 3, active: true },
  { course: 'Financial Literacy Level 2, Part 2', duration: 3, active: true },
  { course: 'Financial Literacy Level 2, Part 3', duration: 3, active: true },
  { course: 'Financial Literacy Level 2, Part 4', duration: 3, active: true },
  { course: 'Financial Literacy Level 2, Part 5', duration: 3, active: true },
  { course: 'Fire Safety and Emergency Preparedness', duration: 1.5, active: true },
  { course: 'Food Safety', duration: 3.5, active: true },
  {
    course: 'Foundational English, Part 1 - Exchanging Personal Information in English',
    duration: 3,
    active: true,
  },
  {
    course: 'Foundational English, Part 2 - Identifying Letters and Numbers on the Keyboard',
    duration: 3,
    active: true,
  },
  {
    course: 'Foundational English, Part 3 - Using and Navigating a Computer',
    duration: 3,
    active: true,
  },
  {
    course: 'Foundational English, Part 4 - Understanding Digital Learning Programs',
    duration: 3,
    active: true,
  },
  {
    course: 'Foundational English, Part 5 - Navigating the Internet Safely',
    duration: 3,
    active: true,
  },
  {
    course: 'Foundational English, Part 6 - Communicating Online - Checking for Errors',
    duration: 3,
    active: true,
  },
  {
    course: 'Foundational English, Part 7 - Communicating Online - Scheduling Virtual Appointments',
    duration: 2,
    active: true,
  },
  { course: 'Foundational ESL, Part 1', duration: 3, active: true },
  { course: 'Foundational ESL, Part 2', duration: 3, active: true },
  { course: 'Foundational ESL, Part 3', duration: 3, active: true },
  { course: 'Foundational ESL, Part 4', duration: 3, active: true },
  { course: 'Foundational ESL, Part 5', duration: 3, active: true },
  { course: 'Foundational ESL, Part 6', duration: 3, active: true },
  { course: 'Foundational ESL, Part 7', duration: 2, active: true },
  {
    course:
      'Harm Reduction: Caring for a Consumer who uses Substances (Drugs or Alcohol) and Is not Ready to Stop',
    duration: 1.5,
    active: true,
  },
  {
    course:
      'Harm Reduction: Caring for a Person Who Uses Substances (Drugs or Alcohol) and is Not Ready to Stop',
    duration: 1,
    active: true,
  },
  { course: 'Heart Disease & Stroke', duration: 1.5, active: true },
  { course: 'HIV & Aids', duration: 1.5, active: true },
  { course: 'Homelessness Systems and Coordinated Entry', duration: 1.5, active: true },
  { course: 'How to Work Skillfully with Big Emotions', duration: 1.5, active: true },
  {
    course: 'Identifying and Mitigating Negative Social Determinants of Health',
    duration: 1.5,
    active: true,
  },
  { course: 'Infection Control', duration: 3, active: true },
  { course: 'Infection Control and Covid Safety', duration: 1.5, active: true },
  { course: 'Intermediate English, Part 1', duration: 3, active: true },
  { course: 'Intermediate English, Part 2', duration: 3, active: true },
  { course: 'Intermediate English, Part 3', duration: 3, active: true },
  { course: 'Intermediate English, Part 4', duration: 3, active: true },
  { course: 'Intermediate English, Part 5', duration: 3, active: true },
  { course: 'Intermediate English, Part 6', duration: 3, active: true },
  { course: 'Intermediate English, Part 7', duration: 2, active: true },
  {
    course: 'Introduction to Basic Human Needs – Online (Instructor Led)',
    duration: 1.5,
    active: true,
  },
  { course: 'Introduction to Basic Human Needs – Online (Self-Paced)', duration: 1, active: true },
  {
    course: 'Introduction to Health Insurance, Benefits & Medical Bills',
    duration: 1.5,
    active: true,
  },
  { course: 'Introduction to Paramedical Care', duration: 1.5, active: true },
  {
    course: 'Introduction to Providing In-Home Care – Online (Instructor Led)',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Introduction to Providing In-Home Care – Online (Self-Paced)',
    duration: 1,
    active: true,
  },
  { course: 'Introduction to Supportive Housing (Asynchronous)', duration: 1, active: true },
  { course: 'Introduction to Supportive Housing (Synchronous)', duration: 1.5, active: true },
  { course: 'Job Readiness Level 1, Part 1', duration: 3, active: true },
  { course: 'Job Readiness Level 1, Part 2', duration: 3, active: true },
  { course: 'Job Readiness Level 1, Part 3', duration: 3, active: true },
  { course: 'Job Readiness Level 1, Part 4', duration: 3, active: true },
  { course: 'Job Readiness Level 1, Part 5', duration: 3, active: true },
  { course: 'Job Readiness Level 2, Part 1', duration: 3, active: true },
  { course: 'Job Readiness Level 2, Part 2', duration: 3, active: true },
  { course: 'Job Readiness Level 2, Part 3', duration: 3, active: true },
  { course: 'Job Readiness Level 2, Part 4', duration: 3, active: true },
  { course: 'Job Readiness Level 2, Part 5', duration: 3, active: true },
  {
    course:
      'Key Concepts of Home Care, Self-Determination, and Self-Direction – Online (Instructor Led)',
    duration: 1.5,
    active: true,
  },
  {
    course:
      'Key Concepts of Home Care, Self-Determination, and Self-Direction – Online (Self-Paced)',
    duration: 1,
    active: true,
  },
  { course: 'Kidney Disease & Dialysis', duration: 1.5, active: true },
  { course: 'Leveraging Community Services and Resources', duration: 1.5, active: true },
  { course: 'Mandatory Reporting and Documentation', duration: 3, active: true },
  { course: 'Medication Safety', duration: 3, active: true },
  { course: 'Mental Health & Well-Being', duration: 1.5, active: true },
  { course: 'Mobility, Ambulation, and Movement', duration: 1.5, active: true },
  {
    course: 'Motivational Interviewing',
    duration: 4,
    active: true,
  },
  {
    course: 'Navigating the Healthcare System & Serving as an Advocate',
    duration: 1.5,
    active: true,
  },
  { course: 'Neurodegenerative Diseases', duration: 1.5, active: true },
  { course: 'OSHA Workplace Safety and Workplace Violence', duration: 3, active: true },
  { course: 'Pain Management', duration: 1.5, active: true },
  { course: 'Palliative Care and Hospice', duration: 1.5, active: true },
  { course: 'Partnering with Family Caregivers', duration: 1.5, active: true },
  { course: 'Personal & Home Safety', duration: 3, active: true },
  { course: 'Personal Care for a Consumer Confined to a Bed', duration: 6.5, active: true },
  { course: 'Personality Disorders', duration: 1.5, active: true },
  { course: 'Physical Changes of Aging and Fall Prevention', duration: 1.5, active: true },
  { course: 'Post-Traumatic Stress Disorder (PTSD)', duration: 1.5, active: true },
  { course: 'Preventing Risk in the Home', duration: 1.5, active: true },
  { course: 'Provider and Consumer Communication', duration: 3, active: true },
  { course: 'Providing Care in the Consumer’s Home', duration: 1.5, active: true },
  { course: 'Psychotherapeutic Meds', duration: 1, active: true },
  { course: 'Psychotic Disorders Including Schizophrenia', duration: 1.5, active: true },
  { course: 'Respecting Differences', duration: 1.5, active: true },
  { course: 'Safety for the Consumer and Provider', duration: 1.5, active: true },
  { course: 'Self Care: Using Mindfulness to Prevent Burnout', duration: 1.5, active: true },
  { course: 'Self-Care', duration: 3, active: true },
  { course: 'Self-Harm & Suicide Prevention', duration: 1.5, active: true },
  { course: 'Simulation: Dementia', duration: 1, active: true },
  { course: 'Simulation: Harm Reduction', duration: 1, active: true },
  { course: 'Simulation: Hoarding & Pests', duration: 1, active: true },
  { course: 'Simulation: Personality Disorder', duration: 1, active: true },
  { course: 'Simulation: Psychosis & Mania', duration: 1, active: true },
  { course: 'Skills Lab: Administering an Enema', duration: 0.5, active: true },
  { course: 'Skills Lab: Administering Eye Drops Properly', duration: 0.5, active: true },
  { course: 'Skills Lab: Administering Naloxone Nasal Spray', duration: 0.5, active: true },
  { course: 'Skills Lab: Catheter Care', duration: 1, active: true },
  { course: 'Skills Lab: Checking Blood Glucose', duration: 0.5, active: true },
  { course: 'Skills Lab: Inserting a Rectal Suppository', duration: 0.5, active: true },
  { course: 'Skills Lab: Ostomy Care & Bag Change', duration: 0.5, active: true },
  { course: 'Skills Lab: Perineal Care for a Bed-Bound Consumer', duration: 1, active: true },
  { course: 'Skills Lab: Tube Feeding Using a Bolus Method', duration: 0.5, active: true },
  { course: 'Skills Lab: Using a Nebulizer', duration: 0.5, active: true },
  { course: 'Skills Lab: Using an Inhaler', duration: 0.5, active: true },
  { course: 'Skills Lab: Using an Insulin Pen', duration: 0.5, active: true },
  { course: 'Skills Lab: Using Eye Ointments Properly', duration: 0.5, active: true },
  { course: 'Standard Precautions', duration: 3, active: true },
  {
    course: 'Supporting Consumers to Use the Bathroom and Manage Incontinence',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Supporting Consumers with Bathing, Dressing & Skin Care',
    duration: 1.5,
    active: true,
  },
  { course: 'Supporting Consumers with Grooming', duration: 1.5, active: true },
  { course: 'Supporting Consumers with Medication Management', duration: 1.5, active: true },
  { course: 'Transitioning from Homelessness', duration: 3, active: true },
  {
    course: 'Transitioning from Homelessness - 1 Hour',
    duration: 1,
    active: true,
  },
  { course: 'Transitions of Care: Hospital or Facility', duration: 1.5, active: true },
  { course: 'Trauma-Informed Approaches to Providing Care', duration: 1, active: true },
  {
    course: 'Trauma-Informed Approaches to Providing Care - 1.5 Hours',
    duration: 1.5,
    active: true,
  },
  { course: 'Understanding the Healthcare Continuum of Care', duration: 1.5, active: true },
  { course: 'Vocational English for Healthcare Professionals, Part 1', duration: 3, active: true },
  { course: 'Vocational English for Healthcare Professionals, Part 2', duration: 3, active: true },
  { course: 'Vocational English for Healthcare Professionals, Part 3', duration: 3, active: true },
  { course: 'Vocational English for Healthcare Professionals, Part 4', duration: 3, active: true },
  { course: 'Vocational English for Healthcare Professionals, Part 5', duration: 3, active: true },
  { course: 'Vocational English for Healthcare Professionals, Part 6', duration: 3, active: true },
  { course: 'Vocational English for Healthcare Professionals, Part 7', duration: 2, active: true },
  { course: 'Working with a Friend or Family Member', duration: 1.5, active: true },
  {
    course: "Working With Consumers Who Can't Communicate Their Needs",
    duration: 1.5,
    active: true,
  },
  {
    course: "Working with Consumers who Don't Speak the Same Language as You",
    duration: 1.5,
    active: true,
  },
];

export const CoursesT2 = [
  {
    course: "10 Warning Signs of Alzheimer's",
    duration: 1,
    active: true,
  },
  {
    course: "A Journey through Alzheimer's",
    duration: 2,
    active: true,
  },
  {
    course: "ABC's of Challenging Behavior",
    duration: 1,
    active: true,
  },
  {
    course:
      "About Alzheimer's Disease and Dementia **offered by Sacramento Aging Disability Resource Connection",
    duration: 1,
    active: true,
  },
  {
    course: 'About Alzheimers Disease & Dementia',
    duration: 0.25,
    active: true,
  },
  {
    course: 'About Falls',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Abuse & Neglect in CA',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Abuse, Neglect and Financial Exploitation',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Abuse, Neglect and Financial Exploitation - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'Actionable Empathy in Behavioral Health',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Actionable Empathy in Dementia',
    duration: 2,
    active: true,
  },
  {
    course: 'Addressing Behavioral Challenges for Caregivers and Direct Care Workers',
    duration: 1.5,
    active: true,
  },
  {
    course: 'ADLs Adaptations for LGBTQ+ Older Adults',
    duration: 2,
    active: true,
  },
  {
    course: 'ADLs Adaptations for LGBTQ+ Older Adults Workshop',
    duration: 1.5,
    active: true,
  },
  {
    course:
      'Advance Topic: Engaging Older Adults with Dementia thru Technology, Music and Arts Therapies',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Caregiver Program',
    duration: 30,
    active: true,
  },
  {
    course: 'Advanced Dementia Training',
    duration: 3,
    active: true,
  },
  {
    course: 'Advanced Topic:  End of Life Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Topic:  Understanding Cultural Aspects of Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Topic: Abuse, Safety, and Injury Prevention',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Topic: Dementia Behavioral Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Topic: Pathways to Success & Career Advancement',
    duration: 2,
    active: true,
  },
  {
    course: 'Advanced Training Track Final',
    duration: 3,
    active: true,
  },
  {
    course: 'Advocacy Skills',
    duration: 2,
    active: true,
  },
  {
    course: 'Aging Changes & Considerations',
    duration: 0.25,
    active: true,
  },
  {
    course: 'All About Food- Nutrition, Spending and Budgeting',
    duration: 1.5,
    active: true,
  },
  {
    course: 'All About Food- Nutrition, Spending and Budgeting - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'All Things Covid-19',
    duration: 1,
    active: true,
  },
  {
    course: 'ALZ Certified',
    duration: 5,
    active: true,
  },
  {
    course:
      "Alzheimer's Disease and Dementia Care, National Council of Certified Dementia Practitioners'",
    duration: 8,
    active: true,
  },
  {
    course: "Alzheimer's Disease and Related Dementias I",
    duration: 2,
    active: true,
  },
  {
    course: "Alzheimer's Disease and Related Dementias II",
    duration: 2,
    active: true,
  },
  {
    course: "Alzheimer's Disease and Related Disorders",
    duration: 1,
    active: true,
  },
  {
    course: "Alzheimer's Disease and Related Disorders: Activities",
    duration: 1,
    active: true,
  },
  {
    course: "Alzheimer's Disease and Related Disorders: Activities of Daily Living (ADL care)",
    duration: 1,
    active: true,
  },
  {
    course: "Alzheimer's Disease and Related Disorders: Behavior and ADL Management",
    duration: 1,
    active: true,
  },
  {
    course: "Alzheimer's Disease and Related Disorders: Behavior Management",
    duration: 1,
    active: true,
  },
  {
    course: "Alzheimer's Disease and Related Disorders: Communication",
    duration: 1,
    active: true,
  },
  {
    course: "Alzheimer's Disease and Related Disorders: Psychosocial Needs",
    duration: 1,
    active: true,
  },
  {
    course: 'Alzheimer’s Disease and Dementia Care Seminar',
    duration: 8,
    active: true,
  },
  {
    course: 'Ambulation with a Gait Belt',
    duration: 0.5,
    active: true,
  },
  {
    course: 'An Overview of Quality Dementia Care',
    duration: 1,
    active: true,
  },
  {
    course: 'Anxiety: Panic, OCD & Paranoia',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Applied Behavioral Analysis Training',
    duration: 45,
    active: true,
  },
  {
    course: 'Applied Behavioral Analysis Training Orientation',
    duration: 2,
    active: true,
  },
  {
    course: 'Arthritis and Exercise',
    duration: 3,
    active: true,
  },
  {
    course: 'Assisting Patients with Hearing Loss in Home Health and Hospice',
    duration: 1,
    active: true,
  },
  {
    course: 'Assisting Patients with Vision Loss in Home Health and Hospice',
    duration: 1,
    active: true,
  },
  {
    course: 'Assisting Resident with Activities of Daily Living',
    duration: 1,
    active: true,
  },
  {
    course: 'Assisting Residents with activities of Daily Living',
    duration: 2,
    active: true,
  },
  {
    course: 'Assisting with ADLs',
    duration: 2,
    active: true,
  },
  {
    course: 'Assisting with Medication Self-Administration',
    duration: 2,
    active: true,
  },
  {
    course: 'Assisting with Personal Care Through ADLs',
    duration: 2,
    active: true,
  },
  {
    course: 'Assisting with Self-Administration of Medications: Procedure',
    duration: 1,
    active: true,
  },
  {
    course: 'Assistive Technology',
    duration: 1,
    active: true,
  },
  {
    course: 'Basic Behavioral Training',
    duration: 40,
    active: true,
  },
  {
    course: 'Basic Care Skills - Skin Care',
    duration: 0.13,
    active: true,
  },
  {
    course: 'Basic First Aid Tips',
    duration: 1,
    active: true,
  },
  {
    course: 'Basics of Hand Hygiene',
    duration: 0.75,
    active: true,
  },
  {
    course: 'Basics of Medication Management',
    duration: 1,
    active: true,
  },
  {
    course: 'Bathing Tips',
    duration: 1,
    active: true,
  },
  {
    course: 'Behavioral Health',
    duration: 4,
    active: true,
  },
  {
    course: 'Behavioral Health Worker - Career Planning and Development',
    duration: 32,
    active: true,
  },
  {
    course: 'Behavioral Health Worker - Critical Reading & Composition',
    duration: 88,
    active: true,
  },
  {
    course: 'Behavioral Health Worker - General Pscyhology',
    duration: 128,
    active: true,
  },
  {
    course: 'Behavioral Health Worker - Intro to Case Management for Human Services',
    duration: 80,
    active: true,
  },
  {
    course: 'Behavioral Health Worker - Introduction to Social Work and Human Services',
    duration: 48,
    active: true,
  },
  {
    course: 'Behavioral Health Worker - Multiethnic /Cultural Communication',
    duration: 88,
    active: true,
  },
  {
    course: "Behaviors and Alzheimer's: Using IDEA!",
    duration: 1,
    active: true,
  },
  {
    course: 'Biomedical Waste Management',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Bipolar Disorder',
    duration: 3,
    active: true,
  },
  {
    course: 'Bloodborne Pathogens',
    duration: 1,
    active: true,
  },
  {
    course: 'Bloodborne pathogens and Standard Precautions',
    duration: 1,
    active: true,
  },
  {
    course: 'Body Mechanics and Supporting Consumers with Transfers',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Body Mechanics I',
    duration: 2,
    active: true,
  },
  {
    course: 'Body Mechanics I Offered by Stanford',
    duration: 2,
    active: true,
  },
  {
    course: 'Body Mechanics II',
    duration: 2,
    active: true,
  },
  {
    course: 'Body Mechanics II Offered by Stanford',
    duration: 2,
    active: true,
  },
  {
    course: 'Body Mechanics with Health and Safety',
    duration: 4,
    active: true,
  },
  {
    course: 'Body Systems and Common Diseases',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Build Your Own Course - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'Build Your Own Course - 2 Hours',
    duration: 2,
    active: true,
  },
  {
    course: 'Build Your Own Course - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'Building Better Caregivers',
    duration: 12,
    active: true,
  },
  {
    course: 'Building Trust Across Computers and Culture',
    duration: 4,
    active: true,
  },
  {
    course: "California Direct Care Worker Training: Alzheimer's Disease and Memory Loss",
    duration: 5,
    active: true,
  },
  {
    course: 'California Direct Care Worker Training: Annual Nutrition, Fluids, and Chocking',
    duration: 5,
    active: true,
  },
  {
    course: 'California Direct Care Worker Training: Brain Health and Memory Loss',
    duration: 5,
    active: true,
  },
  {
    course: 'California Direct Care Worker Training: Cardiovascular and Infectious Disease',
    duration: 5,
    active: true,
  },
  {
    course: 'California Direct Care Worker Training: Death and Dying',
    duration: 5,
    active: true,
  },
  {
    course: 'California Direct Care Worker Training: Mental Health',
    duration: 5,
    active: true,
  },
  {
    course: "California Direct Care Worker Training: Parkinson's Disease",
    duration: 5,
    active: true,
  },
  {
    course: 'California Direct Care Worker Training: Stroke Survivor Care',
    duration: 5,
    active: true,
  },
  {
    course: 'California Direct Care Worker Training: Stroke Types and Care for Survivors',
    duration: 5,
    active: true,
  },
  {
    course: "California Family Caregiver Training: Alzheimer's Disease and Memory Loss",
    duration: 5,
    active: true,
  },
  {
    course: 'California Family Caregiver Training: Annual Nutrition, Fluids, and Chocking',
    duration: 5,
    active: true,
  },
  {
    course: 'California Family Caregiver Training: Brain Health and Memory Loss',
    duration: 5,
    active: true,
  },
  {
    course: 'California Family Caregiver Training: Cardiovascular and Infectious Disease',
    duration: 5,
    active: true,
  },
  {
    course: 'California Family Caregiver Training: Death and Dying',
    duration: 5,
    active: true,
  },
  {
    course: 'California Family Caregiver Training: Mental Health',
    duration: 5,
    active: true,
  },
  {
    course: "California Family Caregiver Training: Parkinson's Disease",
    duration: 5,
    active: true,
  },
  {
    course: 'California Family Caregiver Training: Stroke Survivor Care',
    duration: 5,
    active: true,
  },
  {
    course: 'California Family Caregiver Training: Stroke Types and Care for Survivors',
    duration: 5,
    active: true,
  },
  {
    course: 'California RCFE Prohibited and Restricted Conditions',
    duration: 1,
    active: true,
  },
  {
    course: 'Cancer Pain Management',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Cancer Pain Management - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'Cardiopulmonary Resuscitation',
    duration: 3,
    active: true,
  },
  {
    course: 'Cardiopulmonary Resuscitation Offered by Stanford',
    duration: 3,
    active: true,
  },
  {
    course: 'Care for Individuals with Mental and Physical Disabilities',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Care of LGBTQ Resident in CA',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Care of the Family With Psychotherapeutic Medications',
    duration: 8,
    active: true,
  },
  {
    course: 'Care of the LGBTQ Resident in California',
    duration: 1,
    active: true,
  },
  {
    course: 'Care planning: Preparing for End of Life',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Care Professional I',
    duration: 4,
    active: true,
  },
  {
    course: 'Care Professional II',
    duration: 4,
    active: true,
  },
  {
    course: 'Care Team Dynamics',
    duration: 1,
    active: true,
  },
  {
    course: 'Caregiver Basics',
    duration: 2,
    active: true,
  },
  {
    course: 'Caregiver Conduct',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Caregiver Nutrition Education',
    duration: 2,
    active: true,
  },
  {
    course: 'Caregiver Nutrition Education Offered by Stanford',
    duration: 2,
    active: true,
  },
  {
    course: 'Caregiver Training - Intermediate (Spanish)',
    duration: 15,
    active: true,
  },
  {
    course: 'Caregiver Training - Introductory (Spanish)',
    duration: 15,
    active: true,
  },
  {
    course: 'Caregiver Training Program Part 1',
    duration: 15,
    active: true,
  },
  {
    course: 'Caregiver Training Program Part 2',
    duration: 15,
    active: true,
  },
  {
    course: 'Caregivers',
    duration: 1,
    active: true,
  },
  {
    course: 'Caregiving Essentials',
    duration: 3,
    active: true,
  },
  {
    course: 'Caring for Clients During Chemo',
    duration: 1,
    active: true,
  },
  {
    course: 'Caring for Older Adults: The Aging Process',
    duration: 1,
    active: true,
  },
  {
    course: 'Caring for Your Clients',
    duration: 10,
    active: true,
  },
  {
    course: 'Caring for Your Loved Ones',
    duration: 10,
    active: true,
  },
  {
    course: 'Certificate in End of Life',
    duration: 19,
    active: true,
  },
  {
    course: 'Certified Nursing Assistant (CNA)',
    duration: 12,
    active: true,
  },
  {
    course: 'Certified Nursing Assistant (CNA) Part 1- Bootcamp',
    duration: 12,
    active: true,
  },
  {
    course: 'Certified Nursing Assistant (CNA) Part 2- CNA Training',
    duration: 100,
    active: true,
  },
  {
    course: 'Challenging Behaviors in Dementia Care',
    duration: 2.5,
    active: true,
  },
  {
    course: 'Choking is not Fun',
    duration: 2,
    active: true,
  },
  {
    course: 'Chronic Disease: Screen, Assess, & Refer',
    duration: 8,
    active: true,
  },
  {
    course: 'Chronic Illness',
    duration: 1,
    active: true,
  },
  {
    course: 'Cirrhosis',
    duration: 3,
    active: true,
  },
  {
    course: 'CKD',
    duration: 3,
    active: true,
  },
  {
    course: 'Clinical and Hospice Indications for LGBTQ+ Older Adult',
    duration: 2,
    active: true,
  },
  {
    course: 'Clinical and Hospice Indications for LGBTQ+ Older Adult Workshop',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Clinical Practicum',
    duration: 4,
    active: true,
  },
  {
    course: 'Clinical Practicum - 5 Hours',
    duration: 5,
    active: true,
  },
  {
    course: 'Coaching for Change',
    duration: 4,
    active: true,
  },
  {
    course: 'Code of Ethics',
    duration: 1,
    active: true,
  },
  {
    course: 'Collaboration, Advocacy, Organizational & Professional Skills',
    duration: 8,
    active: true,
  },
  {
    course: 'Common Elderly Diseases',
    duration: 4,
    active: true,
  },
  {
    course: 'Common Elderly Diseases - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'Common Medications and Their Side Effects',
    duration: 1,
    active: true,
  },
  {
    course: 'Common Neurological Conditions in Seniors and Balance',
    duration: 1,
    active: true,
  },
  {
    course: 'Common Respiratory Conditions',
    duration: 1,
    active: true,
  },
  {
    course: 'Communication',
    duration: 3,
    active: true,
  },
  {
    course: 'Communication and Behaviors',
    duration: 4,
    active: true,
  },
  {
    course: 'Communication and Dementia',
    duration: 1,
    active: true,
  },
  {
    course: 'Communication and Engagement Skills',
    duration: 2,
    active: true,
  },
  {
    course: 'Communication and People with Dementia',
    duration: 1,
    active: true,
  },
  {
    course: 'Community Health in Context',
    duration: 2,
    active: true,
  },
  {
    course: 'Community Health Worker Background Knowledge',
    duration: 14,
    active: true,
  },
  {
    course: 'Community Health Worker Best Practices',
    duration: 7,
    active: true,
  },
  {
    course: 'Community Health Worker Foundational Skills',
    duration: 13,
    active: true,
  },
  {
    course: 'Community Health Workers - Introduction to Public Health',
    duration: 128,
    active: true,
  },
  {
    course: 'Community Health Workers - Introduction to Social Work and Human Services',
    duration: 88,
    active: true,
  },
  {
    course: 'Community Health Workers - Medical Terminology & The Human Body',
    duration: 150,
    active: true,
  },
  {
    course: 'Community Health Workers- Orientation',
    duration: 2,
    active: true,
  },
  {
    course: 'Community Health Workers: Health Coach Training',
    duration: 88,
    active: true,
  },
  {
    course: 'Community Health Workers: Health Coach Training I & II',
    duration: 108,
    active: true,
  },
  {
    course: 'Community Health Workers: Health Coach Training III & IV',
    duration: 108,
    active: true,
  },
  {
    course: 'Companion Care/Homemaking, Meal Planning and Preparation',
    duration: 10,
    active: true,
  },
  {
    course: 'Concepts of Effective E-Learning',
    duration: 1,
    active: true,
  },
  {
    course: 'Conflict Resolution Skills',
    duration: 2,
    active: true,
  },
  {
    course: 'Core Caregiving Skills',
    duration: 3,
    active: true,
  },
  {
    course: 'Core Skills Course',
    duration: 1,
    active: true,
  },
  {
    course: 'Course Overview, Community Agencies and History of CHW',
    duration: 8,
    active: true,
  },
  {
    course: 'Covid-19 Vaccines',
    duration: 0.25,
    active: true,
  },
  {
    course: 'CPR & First Aid Certification Training',
    duration: 4,
    active: true,
  },
  {
    course: 'CPR & First Aid Certification Training - 6 Hours',
    duration: 6,
    active: true,
  },
  {
    course: 'CPR/BLS',
    duration: 5,
    active: true,
  },
  {
    course: 'CPT Codes & RPM Care Managing',
    duration: 3,
    active: true,
  },
  {
    course: 'Crisis Intervention Skills',
    duration: 2,
    active: true,
  },
  {
    course: 'Critical Element Pathway: Hospice and End of Life',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Cultural Competence in Healthcare',
    duration: 1,
    active: true,
  },
  {
    course: 'Cultural Diversity and the Older Adult',
    duration: 0.75,
    active: true,
  },
  {
    course: 'Culturally Competent Care: Humility and Responsiveness',
    duration: 6,
    active: true,
  },
  {
    course: 'Custom Caregiving: Meeting the Needs of the Individual',
    duration: 2,
    active: true,
  },
  {
    course: 'Customized Care',
    duration: 3,
    active: true,
  },
  {
    course: 'DARE',
    duration: 8,
    active: true,
  },
  {
    course: 'Data Collection and Digital Literacy',
    duration: 4,
    active: true,
  },
  {
    course: 'Dealing with Behaviorally Challenged Elderly Client',
    duration: 4,
    active: true,
  },
  {
    course: 'Dealing with Behaviorally Challenged Elderly Client - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'Dealing with Dementia',
    duration: 4,
    active: true,
  },
  {
    course: 'Dealing with Dementia **offered by Sacramento Aging Disability Resource Connection',
    duration: 4,
    active: true,
  },
  {
    course: 'Dementia',
    duration: 3,
    active: true,
  },
  {
    course: "Dementia and Alzheimer's",
    duration: 1.5,
    active: true,
  },
  {
    course: 'Dementia Care',
    duration: 4.5,
    active: true,
  },
  {
    course: 'Dementia Care Offered by Stanford',
    duration: 4.5,
    active: true,
  },
  {
    course: "Dementia Care: Alzheimer's and Nutrition",
    duration: 1,
    active: true,
  },
  {
    course: 'Dementia Care: Challenging Behaviors',
    duration: 1,
    active: true,
  },
  {
    course: 'Dementia Care: Helping Families and Friends',
    duration: 0.5,
    active: true,
  },
  {
    course: "Dementia Care: Normal Aging vs. Alzheimer's/Dementia",
    duration: 0.5,
    active: true,
  },
  {
    course: 'Dementia Effects on Activities of Daily Living',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Dementia Live',
    duration: 0.75,
    active: true,
  },
  {
    course: 'Dementia Live - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'Dementia Training Track Final',
    duration: 3,
    active: true,
  },
  {
    course: "Dementia, Alzheimer's Care, Disease Specific Courses",
    duration: 25,
    active: true,
  },
  {
    course: 'Depression',
    duration: 3,
    active: true,
  },
  {
    course: 'Depression, Bi-Polar & Other Mood Disorders',
    duration: 1.5,
    active: true,
  },
  {
    course: 'DHTI Angel Caregiver Certification Series',
    duration: 6,
    active: true,
  },
  {
    course: 'DHTI Angel Caregiver Orientation',
    duration: 2,
    active: true,
  },
  {
    course: 'DHTI Career Coaching for Workplace Readiness & Professional Growth',
    duration: 5.5,
    active: true,
  },
  {
    course: 'Difficult People: Strategies to Keep Everyone Working Together',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Direct Care Workplace Professionalism Starts With You!',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Direct Support Professional Training',
    duration: 15,
    active: true,
  },
  {
    course: 'Direct Support Professionals',
    duration: 40,
    active: true,
  },
  {
    course: 'Disability Awareness Training',
    duration: 1,
    active: true,
  },
  {
    course: 'Disability Justice',
    duration: 1,
    active: true,
  },
  {
    course: 'Disaster Planning',
    duration: 1,
    active: true,
  },
  {
    course: 'Disaster Preparedness',
    duration: 1,
    active: true,
  },
  {
    course: 'Diverity for All Employees for Healthcare',
    duration: 1.25,
    active: true,
  },
  {
    course: 'Documentation',
    duration: 4,
    active: true,
  },
  {
    course: 'Documentation - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'DrKumo RPM Connected Health Training Program Overview',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Early onset/maintenance Heart Failure',
    duration: 3,
    active: true,
  },
  {
    course: 'Early Signs and Symptoms',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Education skills',
    duration: 2,
    active: true,
  },
  {
    course: 'Effective Communication',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Effective Communication **offered by Sacramento Aging Disability Resource Connection',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Effective Communication Skills',
    duration: 1,
    active: true,
  },
  {
    course: 'Effective Team Communication',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Elder Abuse & Neglect',
    duration: 3,
    active: true,
  },
  {
    course: 'Elder Abuse & Neglect (711C)',
    duration: 4,
    active: true,
  },
  {
    course: 'Elderly Depression & Loneliness',
    duration: 4,
    active: true,
  },
  {
    course: 'Elderly Depression & Loneliness - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'Elderly Nutrition',
    duration: 4,
    active: true,
  },
  {
    course: 'Elderly Nutrition - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'Email & Other Messaging',
    duration: 1,
    active: true,
  },
  {
    course: 'Emergency Preparedness Regulations',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Emergency Procedures',
    duration: 1,
    active: true,
  },
  {
    course: 'Emotional Health in Elderly Seniors',
    duration: 4,
    active: true,
  },
  {
    course: 'Emotional Intelligence Feeling & Thinking',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Empowered, Competent, and Compassionate Caregiver',
    duration: 135,
    active: true,
  },
  {
    course: 'Empowering Caregivers: Sharing Experiences and Exploring Supportive Tech Solutions',
    duration: 1,
    active: true,
  },
  {
    course: 'Empowering Residents through ADLs',
    duration: 1,
    active: true,
  },
  {
    course: 'End of Life & Letting Go',
    duration: 2,
    active: true,
  },
  {
    course: 'End of Life Care: Communication',
    duration: 1,
    active: true,
  },
  {
    course: 'Environmental Cleaning',
    duration: 1,
    active: true,
  },
  {
    course: 'Escaping the Binary - Tier 1',
    duration: 2,
    active: true,
  },
  {
    course: 'Escaping the Binary - Tier 1 -  Bi-Monthly Workshop',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Escaping the Binary - Tier 2',
    duration: 2,
    active: true,
  },
  {
    course: 'Escaping the Binary - Tier 2 -  Bi-Monthly Workshop',
    duration: 1.5,
    active: true,
  },
  {
    course: 'ESL for Healthcare Workers',
    duration: 30,
    active: true,
  },
  {
    course: 'Essentials to Person-Centered Memory Care',
    duration: 18,
    active: true,
  },
  {
    course: 'Establishing Healthy Emotional Boundaries',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Establishing Healthy Emotional Boundaries - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'Ethics and Corporate Compliance',
    duration: 1,
    active: true,
  },
  {
    course: 'Exploring Options Approach to Problem Solving',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Fall Risks and Getting Up From a Fall',
    duration: 1,
    active: true,
  },
  {
    course: 'Falls Prevention',
    duration: 3,
    active: true,
  },
  {
    course: 'Family Caregiver Education & Respite Program',
    duration: 20,
    active: true,
  },
  {
    course: 'Fast-Track Respite Care',
    duration: 10,
    active: true,
  },
  {
    course: 'Field work and home visits',
    duration: 1,
    active: true,
  },
  {
    course: 'Fire Safety - CA',
    duration: 3,
    active: true,
  },
  {
    course: 'Fire Safety - California',
    duration: 1,
    active: true,
  },
  {
    course: 'Fire Safety and Emergency Preparedness',
    duration: 1.5,
    active: true,
  },
  {
    course:
      'Fire Safety and Emergency Preparedness **offered by Sacramento Aging Disability Resource Connection',
    duration: 2,
    active: true,
  },
  {
    course: 'First Aid: Section 1',
    duration: 1,
    active: true,
  },
  {
    course: 'First Aid: Section 2',
    duration: 1,
    active: true,
  },
  {
    course: 'Food Preparation and Safety',
    duration: 1,
    active: true,
  },
  {
    course: 'Foot Care in Home Health and Hospice',
    duration: 1,
    active: true,
  },
  {
    course: 'General Client Care',
    duration: 4,
    active: true,
  },
  {
    course: 'General Client Care - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'Glenner GRACE',
    duration: 1,
    active: true,
  },
  {
    course: 'Google Workspace',
    duration: 4,
    active: true,
  },
  {
    course: 'Grief and Resilience',
    duration: 2,
    active: true,
  },
  {
    course: 'Growing the Careforce',
    duration: 15,
    active: true,
  },
  {
    course: 'Guarding Against Abuse',
    duration: 0.75,
    active: true,
  },
  {
    course: 'Guidelines for Effective Professionalism in Direct Support Services Documentation',
    duration: 0.75,
    active: true,
  },
  {
    course: 'Handling Incontinence of Bowel and Bladder',
    duration: 1,
    active: true,
  },
  {
    course: 'Handwashing',
    duration: 1,
    active: true,
  },
  {
    course:
      'Harm Reduction: Caring for a Person who Uses Substances (Drugs or Alcohol) and is Not Ready to Stop',
    duration: 1.5,
    active: true,
  },
  {
    course:
      'Harm Reduction: Caring for a Person Who Uses Substances (Drugs or Alcohol) and is Not Ready to Stop - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'Hazardous Chemicals',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Health and Chronic Conditions',
    duration: 2,
    active: true,
  },
  {
    course: 'Health Care Advocacy for Direct Support Professionals and Caregivers',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Health Literacy, Educate and Coach',
    duration: 4,
    active: true,
  },
  {
    course: 'Healthy Lifestyle',
    duration: 4,
    active: true,
  },
  {
    course:
      'Healthy Relationships for Persons with Disabilities and their Personal Care Assistant(s)',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Helping Clients with Mobility',
    duration: 1,
    active: true,
  },
  {
    course: 'Helping Elderly Parents',
    duration: 24,
    active: true,
  },
  {
    course: 'Helping Prevent Client Elopement',
    duration: 1,
    active: true,
  },
  {
    course: 'Helping with Activities of Daily Living',
    duration: 1,
    active: true,
  },
  {
    course: 'HIPAA Basics',
    duration: 0.5,
    active: true,
  },
  {
    course: 'HIPAA Requirements',
    duration: 3,
    active: true,
  },
  {
    course: 'HIPAA: Social Media',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Home Care Aide Basics',
    duration: 35,
    active: true,
  },
  {
    course: 'Home Caregiver',
    duration: 7,
    active: true,
  },
  {
    course: 'Home Health Aide (HHA)',
    duration: 40,
    active: true,
  },
  {
    course: 'Home Health Assessments',
    duration: 1,
    active: true,
  },
  {
    course: 'Home Safety For Aging In Place',
    duration: 1,
    active: true,
  },
  {
    course: 'Home Visiting & Safety',
    duration: 8,
    active: true,
  },
  {
    course: 'Home Visits and Field Work',
    duration: 15,
    active: true,
  },
  {
    course: 'Homelessness Systems and Coordinated Entry',
    duration: 1.5,
    active: true,
  },
  {
    course: "Honoring Patients' Rights",
    duration: 0.5,
    active: true,
  },
  {
    course: 'Hospice in LTC: Philosophy of Care',
    duration: 1,
    active: true,
  },
  {
    course: 'Hospice/End of Life Care',
    duration: 6,
    active: true,
  },
  {
    course: 'Housekeeping Basic',
    duration: 4,
    active: true,
  },
  {
    course: 'How to Communicate with Someone with Dementia',
    duration: 1,
    active: true,
  },
  {
    course: 'How to Work Skillfully with Big Emotions',
    duration: 1.5,
    active: true,
  },
  {
    course: 'How to Work Skillfully with Big Emotions - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'Human Touch Healthcare',
    duration: 12,
    active: true,
  },
  {
    course: 'Hypertension and Hypertensive Disorder',
    duration: 3,
    active: true,
  },
  {
    course: 'Identifying Fall Risk in Assisted Living',
    duration: 1,
    active: true,
  },
  {
    course:
      'Impacts of Social Determinants of Health in Older Adults and the Role of Community Health Workers and Promotores',
    duration: 3,
    active: true,
  },
  {
    course:
      'Impacts of Social Determinants of Health in Older Adults and the Role of Community Health Workers and Promotores - 2 Hours',
    duration: 2,
    active: true,
  },
  {
    course: 'Implicit Bias in Healthcare',
    duration: 0.25,
    active: true,
  },
  {
    course: 'In-Person ADL Training and Skills Assessment',
    duration: 3,
    active: true,
  },
  {
    course: 'Inclusive Care Direct Care Worker Live Group Online Coaching Sessions',
    duration: 3,
    active: true,
  },
  {
    course:
      'Inclusive Care: Training to Support Direct Care Professionals Working with Elderly and Disabled Populations',
    duration: 15,
    active: true,
  },
  {
    course: 'Infection Control & COVID 19',
    duration: 4,
    active: true,
  },
  {
    course: 'Infection Control & COVID 19 - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'Infection Control & Prevention',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Infection Control and Covid Safety',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Infection Control and Covid Safety - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'Infection Control: Basic Concepts',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Infectious Illness (COVID, Influenza, etc.)',
    duration: 3,
    active: true,
  },
  {
    course: 'Insurance, Government Funded Programs, and Community Resources',
    duration: 2,
    active: true,
  },
  {
    course: 'Intro to Healthcare Pathways',
    duration: 8,
    active: true,
  },
  {
    course: 'Introduction to Care in the Home and Caring for Yourself',
    duration: 10,
    active: true,
  },
  {
    course: 'Introduction to Caregiving',
    duration: 4,
    active: true,
  },
  {
    course: 'Introduction to Caregiving - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'Introduction to Caregiving and Home Health',
    duration: 25,
    active: true,
  },
  {
    course: 'Introduction to Community Health Workers',
    duration: 9,
    active: true,
  },
  {
    course: 'Introduction to Dementia Care',
    duration: 2,
    active: true,
  },
  {
    course: 'Introduction to Emotional Wellness Support & Creating Community',
    duration: 3,
    active: true,
  },
  {
    course: 'Introduction to Hospice',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Introduction to Personal Care Courses (101-111)',
    duration: 25,
    active: true,
  },
  {
    course: 'Introduction to Remote Patient Monitoring (RPM) and Healthcare',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Introduction To Team Building',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Introductory Training Track Final',
    duration: 3,
    active: true,
  },
  {
    course: 'Jump Start Your Job Search',
    duration: 1,
    active: true,
  },
  {
    course: 'Kinary- Where Caregiving & Life Balance can Co-exist for Direct Care Workers',
    duration: 1,
    active: true,
  },
  {
    course: 'Kinary- Where Caregiving & Life Balance can Co-exist for Family Caregivers',
    duration: 1,
    active: true,
  },
  {
    course: 'Knowing the Rights of Residents',
    duration: 1,
    active: true,
  },
  {
    course: 'Maintaining Clean and Healthy Environment',
    duration: 2,
    active: true,
  },
  {
    course: 'Making Home Safe for a Person With Alzheimer’s',
    duration: 1,
    active: true,
  },
  {
    course: "Making the Most of Your Doctor's Visit",
    duration: 0.25,
    active: true,
  },
  {
    course: 'Managing Challenging Dementia Behaviors',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Managing Chronic Disease for Older Adults',
    duration: 3,
    active: true,
  },
  {
    course: 'Managing Emotions',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Managing Grief',
    duration: 3,
    active: true,
  },
  {
    course: 'Managing Job-Related Stress',
    duration: 1,
    active: true,
  },
  {
    course: 'Managing Stress',
    duration: 0.25,
    active: true,
  },
  {
    course:
      'Managing Stress and Avoiding Burnout for Direct Care Workers and Unpaid Family Caregivers',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Managing Stress Offered by Stanford',
    duration: 3,
    active: true,
  },
  {
    course: 'Managing your Time in Home Health and Hospice',
    duration: 1,
    active: true,
  },
  {
    course: 'Mandated Reporting: Elder and Dependent Adult Abuse and Neglect in California',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Measuring Vital Signs',
    duration: 2,
    active: true,
  },
  {
    course: 'Mechanical Lift Use and Safety',
    duration: 1,
    active: true,
  },
  {
    course: 'Medication Administraiton Basics',
    duration: 1,
    active: true,
  },
  {
    course: 'Medication Management',
    duration: 1,
    active: true,
  },
  {
    course: 'Medications and Dementia',
    duration: 1,
    active: true,
  },
  {
    course: 'Medications and Fall Risk',
    duration: 1,
    active: true,
  },
  {
    course: 'Memory Loss',
    duration: 1,
    active: true,
  },
  {
    course: "Memory Loss & Alzheimer's",
    duration: 1,
    active: true,
  },
  {
    course: 'Mental Health & Wellbeing',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Mental Health & Wellbeing - 1 Hour',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Mental Health and Substance Use',
    duration: 2,
    active: true,
  },
  {
    course: 'Minimizing Trips, Slips, and Falls',
    duration: 1,
    active: true,
  },
  {
    course: 'Mobility Assistance',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Mobility, Ambulation and Movement',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Motivational Interviewing',
    duration: 8,
    active: true,
  },
  {
    course: 'Multiple Chronic Conditions',
    duration: 6,
    active: true,
  },
  {
    course: 'Multiple Sclerosis',
    duration: 3,
    active: true,
  },
  {
    course: 'Natural Disasters & Workplace Emergencies',
    duration: 1,
    active: true,
  },
  {
    course: 'Nurse Assistant Training Program (CNA)',
    duration: 160,
    active: true,
  },
  {
    course: 'Nutrition and Meal Preparation for Older Adults',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Nutrition Basics in Home Health and Hospice',
    duration: 1,
    active: true,
  },
  {
    course: 'Observing, Reporting, and Documenting',
    duration: 1,
    active: true,
  },
  {
    course: 'Obtaining a Restraint-Free Environment',
    duration: 1,
    active: true,
  },
  {
    course: 'Older Adult Fall Prevention',
    duration: 3,
    active: true,
  },
  {
    course: 'Older Adult Sensitivity Training',
    duration: 2,
    active: true,
  },
  {
    course: 'Online Safety',
    duration: 1,
    active: true,
  },
  {
    course: 'Overview of Depression Care',
    duration: 1,
    active: true,
  },
  {
    course: 'Overview of Mental Illness & Caring for Adults with Hoarding Disorder',
    duration: 2,
    active: true,
  },
  {
    course: 'Overview of Nutrition and Food Preparation',
    duration: 2,
    active: true,
  },
  {
    course: 'Overview of Skin Care and Wound Prevention',
    duration: 2,
    active: true,
  },
  {
    course: 'Overview of Transfers and Mobility Equipment',
    duration: 2,
    active: true,
  },
  {
    course: 'Oxygen Safety for Caregivers',
    duration: 1,
    active: true,
  },
  {
    course: 'Pain & the Elderly',
    duration: 4,
    active: true,
  },
  {
    course: 'Pain & the Elderly - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'Pain Management',
    duration: 3,
    active: true,
  },
  {
    course: 'Palliative Care',
    duration: 3,
    active: true,
  },
  {
    course: 'Palliative Care **offered by Futuro Health',
    duration: 3,
    active: true,
  },
  {
    course: 'Palliative Care and Hospice',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Palliative Care and Hospice - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'Palliative Care and Hospice Care',
    duration: 30,
    active: true,
  },
  {
    course: 'Patient Centered Communication',
    duration: 3,
    active: true,
  },
  {
    course: 'Performing Safe Transfers',
    duration: 1,
    active: true,
  },
  {
    course: 'Person Center Counseling for Behavior Change Implementation and Follow-Up',
    duration: 4,
    active: true,
  },
  {
    course: 'Person Centered Care Planning for Dementia',
    duration: 1,
    active: true,
  },
  {
    course: 'Person Centered Care: The Art & Science of Effective Caregiving',
    duration: 2,
    active: true,
  },
  {
    course: 'Person Centered Dementia Care',
    duration: 1,
    active: true,
  },
  {
    course: 'Personal Care',
    duration: 3,
    active: true,
  },
  {
    course: 'Personal Care for Consumers Confined to Bed',
    duration: 6.5,
    active: true,
  },
  {
    course: 'Personal Care for Consumers Confined to Bed - 1.5 Hours',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Personal Care Tasks/ Skills With Care Manager',
    duration: 4,
    active: true,
  },
  {
    course: 'Physical Care at End of Life',
    duration: 1,
    active: true,
  },
  {
    course: 'Physical Changes of Aging and Fall Prevention',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Physical Changes of Aging and Fall Prevention - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course:
      'Physical Safety and Accident/Injury Prevention Amongst Direct Care Workers and Family Caregivers',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Positive Behavior Management',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Post-COVID symptoms',
    duration: 3,
    active: true,
  },
  {
    course: 'Post-Traumatic Stress Disorder',
    duration: 3,
    active: true,
  },
  {
    course: 'Post-Traumatic Stress Disorder - 1.5 Hours',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Powerful Tools for Caregivers',
    duration: 15,
    active: true,
  },
  {
    course:
      'Powerful Tools for Caregivers **offered by Sacramento Aging Disability Resource Connection',
    duration: 9,
    active: true,
  },
  {
    course: 'Practical Communication Skills',
    duration: 0.25,
    active: true,
  },
  {
    course: "Preparing for a Doctor's Appointment",
    duration: 0.25,
    active: true,
  },
  {
    course: 'Preventing and Managing Accidents',
    duration: 2,
    active: true,
  },
  {
    course: 'Preventing Infections & Falls',
    duration: 1,
    active: true,
  },
  {
    course: 'Preventing Risk in the Home',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Preventing Risk in the Home - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'Preventing, Recognizing, and Reporting Abuse',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Prevention of Back Injuries',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Privacy and Safety in Caregiving',
    duration: 5,
    active: true,
  },
  {
    course: 'Privacy, Rights, and Self Determination of Clients',
    duration: 1,
    active: true,
  },
  {
    course: 'Problem Solving In The Work Place',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Professional Boundaries and Self-Care Skills',
    duration: 2,
    active: true,
  },
  {
    course: 'Proper Positioning',
    duration: 1,
    active: true,
  },
  {
    course: 'Providing Care at End of Life',
    duration: 1,
    active: true,
  },
  {
    course: "Providing Care in Consumer's Home",
    duration: 1.5,
    active: true,
  },
  {
    course: 'Providing Care to LGBTQ+ Clients',
    duration: 1,
    active: true,
  },
  {
    course: 'Providing Client-Centered Care',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Providing Customer Service',
    duration: 1,
    active: true,
  },
  {
    course: 'Providing Homecare to LGBT Older Adults',
    duration: 1,
    active: true,
  },
  {
    course: 'Psychosocial Issues',
    duration: 1,
    active: true,
  },
  {
    course: 'Psychotic Disorder',
    duration: 3,
    active: true,
  },
  {
    course: 'Psychotic Disorders Including Schizophrenia',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Recognizing and Responding to Alzheimer’s and Related Dementia',
    duration: 3,
    active: true,
  },
  {
    course: 'Recognizing Burnout Offered by Stanford',
    duration: 3,
    active: true,
  },
  {
    course: 'Recognizing Fire & Medical Emergencies',
    duration: 2,
    active: true,
  },
  {
    course: 'Remote Patient Monitoring Technical Application',
    duration: 2,
    active: true,
  },
  {
    course: 'Reporting and Documenting Client Care',
    duration: 1,
    active: true,
  },
  {
    course: 'Reporting Elder Abuse',
    duration: 1,
    active: true,
  },
  {
    course: 'Resident to Resident Altercations: Bullying',
    duration: 1.25,
    active: true,
  },
  {
    course: 'Respecting Differences',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Respecting Diversity',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Restorative Nursing',
    duration: 1,
    active: true,
  },
  {
    course: 'Restorative Nursing Program (RNA)',
    duration: 16,
    active: true,
  },
  {
    course: 'Role of Caregiver',
    duration: 4,
    active: true,
  },
  {
    course: 'Role of Caregiver - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'Roles and Responsibilities of Direct Care Workers',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Root Causes and Role of CHW',
    duration: 4,
    active: true,
  },
  {
    course: 'RPM & COPD',
    duration: 3,
    active: true,
  },
  {
    course: 'RPM & Diabetes',
    duration: 3,
    active: true,
  },
  {
    course: 'RPM & Heart Disease',
    duration: 3,
    active: true,
  },
  {
    course: 'RPM & Sleep Apnea',
    duration: 3,
    active: true,
  },
  {
    course: 'RPM Activities of Daily Living (ADL)',
    duration: 4,
    active: true,
  },
  {
    course: 'RPM Onboarding',
    duration: 2,
    active: true,
  },
  {
    course: 'Safe Transferring and Repositioning',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Safety for the Consumer & Provider',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Safety in the Home',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Safety Precautions and Fall Prevention',
    duration: 2,
    active: true,
  },
  {
    course: 'Safety, Risk and Privacy',
    duration: 2,
    active: true,
  },
  {
    course: "San Diego County's Aging Ecosystem",
    duration: 1,
    active: true,
  },
  {
    course: 'Selecting Dementia and Appropriate Activities',
    duration: 1,
    active: true,
  },
  {
    course: 'Self-Care Best Practices for Healthcare Professionals and Family Caregivers',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Self-Care for Frontline Professionals',
    duration: 1,
    active: true,
  },
  {
    course: 'Self-Care Matters Class Series ',
    duration: 3,
    active: true,
  },
  {
    course: 'Self-Care- Using Mindfulness to Prevent Burnout',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Self-Care- Using Mindfulness to Prevent Burnout - 1 Hour',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Self-Care: Digestion Offered by Stanford',
    duration: 3,
    active: true,
  },
  {
    course: 'Self-Care: Optimizing Sleep & Rest Offered by Stanford',
    duration: 3,
    active: true,
  },
  {
    course: 'Sexual Acting out - Dementia Care',
    duration: 2.5,
    active: true,
  },
  {
    course: 'Sexual Harassment for Employees',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Sing me a Song',
    duration: 10,
    active: true,
  },
  {
    course: 'Skin Care in the Elderly',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Slips, Trips & Falls Prevention',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Social Risk and Social Needs',
    duration: 2,
    active: true,
  },
  {
    course: 'Stanford LEAD: A multi-cultural training program',
    duration: 8,
    active: true,
  },
  {
    course: 'Stress and Caregiver Burnout',
    duration: 2,
    active: true,
  },
  {
    course: 'Stress and Self-Care',
    duration: 5,
    active: true,
  },
  {
    course: 'Stress and Trauma',
    duration: 2,
    active: true,
  },
  {
    course: 'Substance Use Disorder',
    duration: 3,
    active: true,
  },
  {
    course: 'SUCCEDD Training',
    duration: 32,
    active: true,
  },
  {
    course: 'Successful Aging in Place',
    duration: 1,
    active: true,
  },
  {
    course: 'Summer Safety Tips',
    duration: 1,
    active: true,
  },
  {
    course: 'Supervisit: Observation & Practice of Caregiving',
    duration: 1,
    active: true,
  },
  {
    course: 'Supporting Caregivers for Those With Balance Issues',
    duration: 1,
    active: true,
  },
  {
    course: 'Supporting Consumers to Use the Bathroom & Incontinence',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Supporting Consumers with Bathing, Dressing & Skin Care',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Supporting Consumers with Grooming',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Supporting Consumers with Medication Management',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Supporting Consumers with Medication Management - 1 Hour',
    duration: 1,
    active: true,
  },
  {
    course: 'Tablet Basics: Your Device and Its Capabilities',
    duration: 1,
    active: true,
  },
  {
    course: 'Technology Question & Answer (Q&A)',
    duration: 1,
    active: true,
  },
  {
    course: 'Teepa Snow Dementia Training',
    duration: 15,
    active: true,
  },
  {
    course: 'Teepa Snow Seeing it From the Other Side Dementia Training',
    duration: 5,
    active: true,
  },
  {
    course: 'Telehealth',
    duration: 1,
    active: true,
  },
  {
    course: 'Telehealth Basics',
    duration: 1,
    active: true,
  },
  {
    course: 'The Aging Process and Working with the Elderly',
    duration: 3,
    active: true,
  },
  {
    course: 'The Basics of Workplace Safety',
    duration: 0.5,
    active: true,
  },
  {
    course: "The Basics: Memory Loss, Dementia and Alzheimer's Disease",
    duration: 1.5,
    active: true,
  },
  {
    course: 'The Care Coordination Processes',
    duration: 3,
    active: true,
  },
  {
    course: 'The Cognitive Decline with Aging',
    duration: 6,
    active: true,
  },
  {
    course: 'The Dementia Challenge',
    duration: 2,
    active: true,
  },
  {
    course: 'The Emotional Aspect of Aging and Disability',
    duration: 14,
    active: true,
  },
  {
    course: 'The Future is Now Class Series',
    duration: 9,
    active: true,
  },
  {
    course: 'The Meaning Behind Behaviors',
    duration: 0.5,
    active: true,
  },
  {
    course: 'The Process of Aging',
    duration: 1.25,
    active: true,
  },
  {
    course: 'The Stanford LEADER Program',
    duration: 40,
    active: true,
  },
  {
    course: 'Therapeutic Communication',
    duration: 0.5,
    active: true,
  },
  {
    course: 'Tobacco Cessation',
    duration: 3,
    active: true,
  },
  {
    course: 'Toileting Tips',
    duration: 1,
    active: true,
  },
  {
    course: 'Toxic Stress & Resiliency',
    duration: 4,
    active: true,
  },
  {
    course: 'Train Patient on RPM',
    duration: 2,
    active: true,
  },
  {
    course: 'Train the Trainer',
    duration: 8,
    active: true,
  },
  {
    course: 'Transfers, Personal Care',
    duration: 16,
    active: true,
  },
  {
    course: 'Trauma Informed Care **offered by Futuro Health',
    duration: 3,
    active: true,
  },
  {
    course: 'Trauma- Informed Approaches to Providing Care',
    duration: 1,
    active: true,
  },
  {
    course: 'Trauma- Informed Care',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Understanding & Responding To Dementia-Related Behaviors',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Activities of Daily Living',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Understanding ADLs',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Understanding Alzheimer’s Disease Behaviors Seminar',
    duration: 2,
    active: true,
  },
  {
    course: 'Understanding Brain and Spinal Cord Injuries',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding C Difficile',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Common Cognitive and Physical Diagnoses',
    duration: 14,
    active: true,
  },
  {
    course: 'Understanding Common GI Disorders',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Congestive Heart Failure',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Cultural Differences',
    duration: 4,
    active: true,
  },
  {
    course: 'Understanding Cultural Differences - 3 Hours',
    duration: 3,
    active: true,
  },
  {
    course: 'Understanding Dementia in Home Health and Hospice',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Diabetes',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Drug Resistant Bacteria',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Eye Disorders',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Hearing Disorders',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Heart Attacks',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Hospice',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Latex Allergies',
    duration: 0.25,
    active: true,
  },
  {
    course: 'Understanding Nutrition and Hydration',
    duration: 0.75,
    active: true,
  },
  {
    course: 'Understanding Palliative Care',
    duration: 1,
    active: true,
  },
  {
    course: "Understanding Parkinson's Disease",
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Seizures',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding Sexual Harassment',
    duration: 1,
    active: true,
  },
  {
    course: 'Understanding the Healthcare Continuum of Care',
    duration: 1.5,
    active: true,
  },
  {
    course: "Understanding the Stages of Alzheimer's Disease",
    duration: 1,
    active: true,
  },
  {
    course: 'Unleash Your Tech Wizardry: Dive into the World of Device Magic',
    duration: 1,
    active: true,
  },
  {
    course: 'Using Applications & Browsing the Internet',
    duration: 1,
    active: true,
  },
  {
    course:
      'Vestibular Conditions (Dizziness, Light Headedness and Vertigo) in Older Adults and Their Treatment',
    duration: 1,
    active: true,
  },
  {
    course: 'Vital Signs',
    duration: 2,
    active: true,
  },
  {
    course: 'Weight Management',
    duration: 3,
    active: true,
  },
  {
    course: 'WH_01 Resilience in Adversity',
    duration: 6,
    active: true,
  },
  {
    course: 'WH_02 Cultural Competency',
    duration: 6,
    active: true,
  },
  {
    course: 'WH_03 Enhanced Preceptor',
    duration: 3,
    active: true,
  },
  {
    course: 'WH_04 CNA to HHA Certification',
    duration: 40,
    active: true,
  },
  {
    course: 'Wheelchairs and Other Ambulatory Aids',
    duration: 1,
    active: true,
  },
  {
    course: 'Who are Community Health Workers?',
    duration: 1,
    active: true,
  },
  {
    course: 'Working With a Team',
    duration: 1,
    active: true,
  },
  {
    course: 'Working With Consumers Who Are Non-Communicative',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Working With the Elder Population',
    duration: 6,
    active: true,
  },
  {
    course: 'Wound Care',
    duration: 3,
    active: true,
  },
  {
    course:
      'Writing the Work Agreement: Healthy Relationships for Persons with Disabilities and their Personal Care Assistant(s)',
    duration: 1.5,
    active: true,
  },
  {
    course: 'Your Role as a Non-Medical Caregiver',
    duration: 1,
    active: true,
  },
  {
    course: "Your Role in Recognizing, Prevention and Treating UTI's",
    duration: 1,
    active: true,
  },
];

export type Training = {
  name: string;
  creditHours: number;
  courseProof: Document[];
};

export type CompletedCourses = {
  courses: Training[];
  totalCreditHours: number;
};

export interface CellEdApplicationAnswers {
  age?: {
    skipped?: boolean;
    age?: string;
  };
  gender?: {
    skipped?: boolean;
    gender?: string[];
    otherGender?: string;
  };
  ethnicity?: {
    skipped?: boolean;
    ethnicity?: string[];
    otherEthnicity?: string;
  };
  language?: {
    skipped?: boolean;
    language?: string;
  };
  educationLevel?: {
    skipped?: boolean;
    educationLevel?: string;
  };
  workZipcode?: {
    skipped?: boolean;
    workZipcode?: number;
  };
  householdIncome?: {
    skipped?: boolean;
    annualAmount?: string;
  };
  jobTitle?: string;
  employer?: string;
  employerAddressId?: string;
  address?: {
    mailingAddressId?: string;
  };
  supervisorName?: { firstName: string; lastName: string };
  supervisorPhone?: string;
  firstTimeApplying?: string;
  incentiveLevel?: string;
  // QUESTIONS GROUP LEVEL 1
  courseCompletedL1?: CompletedCourses;
  // QUESTIONS GROUP SECOND LEVEL 1
  courseCompletedSL1?: CompletedCourses;
  // QUESTIONS GROUP LEVEL 2
  workingDirectCareWorkL2?: 'yes' | 'no';
  courseCompletion?: 'yes' | 'no';
  numberEmployerL2?: 'yes' | 'no';
  additionalEmployerL2?: {
    name: string;
  }[];
  // QUESTIONS GROUP LEVEL 3
  courseCompletionL3?: 'yes' | 'no';
  workingDirectCareWorkL3?: 'yes' | 'no';
  numberEmployerL3?: 'yes' | 'no';
  additionalEmployerL3?: {
    name: string;
  }[];
  //DOCUMENTS
  documents: {
    proofEmployment?: string[];
    paystub?: string;
    employmentCertificate?: string;
  };
}
